/* eslint-disable */
import React, {
  FunctionComponent,
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import TextField from "@material-ui/core/TextField";
import CircularProgress from "@material-ui/core/CircularProgress";
import clsx from "clsx";
import { useRecoilValue, useRecoilState } from "recoil";
import {
  Dartboard,
  InfoIcon,
  PersonIcon,
  PersonRoundedIcon,
  PersonWithPlusIcon,
  VerifiedIcon,
} from "../../assets/Icons";
import Button from "../../components/ui/Button";
import { transactionDetails, declarationDefault } from "../../store";
import { UserTransactionDetails } from "../../store/store";
import IReviewPage from "./ReviewPage";
import Autocomplete from "@material-ui/lab/Autocomplete";
import ErrorField from "../../components/ui/ErrorField";
import DeclarationModal from "./DeclarationDetailModal";
import ProfileOutline from "../../assets/Icons/ProfileOutline";
import MixpanelConfig from "../../constants/MixpanelConfig";

export const PaymentOverview: FunctionComponent<IReviewPage.PaymentOverviewProps> = ({
  handleClick,
  errorMessage,
  handleA2Form,
  setIsModalOpen,
  dualNumber,
  setDualNumber,
  verifyDual,
  dualError,
  dualVerified,
  referrer,
  setReferrer,
  vendorCodes,
  signA2FormStatus,
  handleSignA2Form,
  eSign,
  signLater,
  linkSent,
  viewA2Form,
  isViewingA2Form,
  A2errorMessage,
  setSourceOfFunds,
  sourceOfFunds,
  setErrorMessage,
  consentCheckbox,
  setConsentCheckbox,
  contentData,
  setIsContentModalOpen,
}) => {
  const [transactionData, setTransactionData] = useRecoilState(transactionDetails);
  const [inputValue, setInputValue] = React.useState("");
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  const [defaultDeclaration, setDefaultDeclaration] = useRecoilState(declarationDefault);
  const [isCheckedTermsAndCondition, setIsCheckedTermsAndCondition] =
    React.useState<boolean>(false);
  const [isCheckedA2Form, setIsCheckedA2Form] = React.useState<boolean>(false);
  const [disablePay, setDisablePay] = React.useState<boolean>(true);
  const [declaration, setDeclarationy] = React.useState<boolean>(false);
  const [modalOpen, setModalOpen] = useState(false);
  const modalRef = useRef<HTMLDivElement>(null);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const [trxnDeclarations, setTrxnDeclarations] = useState<any>(defaultDeclaration);
  const [lanNumber, setLanNumber] = useState<string>("");
  const [utrNumber, setUtrNumber] = useState<string>("");

  const [lanVerified, setLanVerified] = useState<boolean>(false);
  const [lanChecking, setLanChecking] = useState<boolean>(false);
  const lanVerifyTimeout = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    return () => {
      if (lanVerifyTimeout.current) {
        clearTimeout(lanVerifyTimeout.current);
      }
    };
  }, []);

  const [showDeclaration, setShowDeclaration] = React.useState<boolean>(false);
  const declarationModalRef = React.useRef<IDeclarationModal.IDeclarationModalHandles>(null);

  const handleClearModalState = () => {
    declarationModalRef.current?.clearState();
  };

  const lanMandatoryCheck = localStorage.getItem("lanMandatory");

  React.useEffect(() => {
    setDefaultDeclaration({
      vendorCode: "select",
      lanNumber: null,
      paymentUtr: null,
    });
    handleClearModalState();
  }, [declarationModalRef]);

  const handleTermsAndCondition = () => {
    setIsCheckedTermsAndCondition(!isCheckedTermsAndCondition);
  };

  const handleAgreeA2Form = () => {
    setIsCheckedA2Form(!isCheckedA2Form);
  };

  useMemo(() => {
    if (currentUser.username.includes("moneyhop.co")) {
      if (!lanMandatoryCheck || lanMandatoryCheck === "false" || lanMandatoryCheck === undefined) {
        setDisablePay(
          !Boolean(
            isCheckedTermsAndCondition && isCheckedA2Form && sourceOfFunds !== "" && consentCheckbox
          )
        );
      } else {
        setDisablePay(
          !Boolean(
            isCheckedTermsAndCondition &&
              isCheckedA2Form &&
              sourceOfFunds !== "" &&
              lanNumber !== "" &&
              lanNumber.length === 12 &&
              lanVerified &&
              consentCheckbox
          )
        );
      }
    } else {
      setDisablePay(
        !Boolean(
          isCheckedTermsAndCondition && isCheckedA2Form && sourceOfFunds !== "" && consentCheckbox
        )
      );
    }
  }, [
    isCheckedTermsAndCondition,
    isCheckedA2Form,
    lanMandatoryCheck,
    lanNumber,
    sourceOfFunds,
    lanVerified,
    consentCheckbox,
  ]);

  const buttonStyle = {
    fontFamily: "font-roboto",
    fontSize: "text-base",
    fontWeight: "font-bold",
    fontColor: "text-white",
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
      setModalOpen(false);
    }
  };

  useEffect(() => {
    if (modalOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [modalOpen]);

  useEffect(() => {
    if (errorMessage == "Invalid Total Pay") {
      setErrorMessage(
        "Incorrect total pay, rates have updated, please re-initiate the transaction"
      );
    } else if (errorMessage == "Incorrect Recipient Receive Amount") {
      setErrorMessage(
        "Incorrect Receive Amount, rates have updated, please re-initiate the transaction"
      );
    } else if (errorMessage == "Invalid recipient is passed") {
      setErrorMessage("Invalid Recipient selected, please select correct mapped recipient");
    }
  }, [errorMessage]);

  const sourceData = [
    {
      label: "salary or wages",
      value: "Salary or Wages",
    },
    {
      label: "student loan",
      value: "Student Loan",
    },
    {
      label: "investments",
      value: "Investments",
    },
    {
      label: "personal savings",
      value: "Personal Savings",
    },
    {
      label: "personal wealth",
      value: "Personal Wealth",
    },
    {
      label: "retirement funds",
      value: "Retirement Funds",
    },
    {
      label: "business owner/share holder",
      value: "Business Owner/Share Holder",
    },
  ];

  const selectSource = (source: { label: string; value: string }) => {
    setSourceOfFunds(source.value);
    setModalOpen(false);
  };

  useEffect(() => {
    const data = {
      vendorCode: JSON.parse(localStorage.getItem("vendorCode") || "{}")?.vendorCode,
      lanNumber: lanNumber,
      paymentUtr: utrNumber,
    };

    setTransactionData({ ...transactionData, trxnDeclarations: data });
    setDefaultDeclaration(data);
  }, [lanNumber, utrNumber]);

  return (
    <div className="flex flex-col p-5 mt-0 space-y-5 w-[85%]">
      <div className="flex items-center gap-3">
        <div
          id="purpose"
          className="h-12 w-[440px] border border-gray-300 flex items-center gap-2 rounded-md p-4 bg-gray-100 text-[14px] cursor-not-allowed"
        >
          <span className="float-left font-semibold">Purpose of Payment:</span>
          {transactionData?.transaction_purpose
            ? transactionData?.transaction_purpose
            : "Select Purpose of Payment"}
        </div>
      </div>
      <div className="flex items-center gap-3">
        <div
          id="vendorCode"
          className="h-12 w-[440px] border border-gray-300 flex items-center gap-2 rounded-md p-4 bg-gray-100 text-[14px] cursor-not-allowed"
        >
          <span className="float-left font-semibold">Vendor Code:</span>
          {JSON.parse(localStorage.getItem("vendorCode") || "{}")?.vendorCode}
        </div>
      </div>

      {currentUser.username.includes("moneyhop.co") && (
        <>
          <div className="flex items-center gap-3">
            <div
              id="lanNO"
              className="h-12 w-[440px] border border-gray-300 flex items-center gap-2 rounded-md p-4 bg-gray-100 text-[14px]"
            >
              <span className="float-left font-semibold">
                LAN No:
                <span className="text-red-100 text-lg pl-1">
                  {lanMandatoryCheck === "true" ? "*" : ""}
                </span>
              </span>
              <input
                type="text"
                value={lanNumber}
                className="bg-gray-100 text-[14px] text-black outline-none flex-1"
                onChange={(e) => {
                  const input = e.target.value;
                  const alphanumericOnly = input.replace(/[^a-zA-Z0-9]/g, "");
                  MixpanelConfig.trackEvent(MixpanelConfig.eventNames.Old_Review_LAN_Enter, {
                    transactionData: transactionData,
                    lanValue: alphanumericOnly,
                  });
                  if (alphanumericOnly.length <= 12) {
                    setLanNumber(alphanumericOnly);
                    if (alphanumericOnly.length === 12) {
                      if (lanVerifyTimeout.current) {
                        clearTimeout(lanVerifyTimeout.current);
                      }
                      setLanChecking(true);
                      setLanVerified(false);
                      lanVerifyTimeout.current = setTimeout(() => {
                        setLanChecking(false);
                        setLanVerified(true);
                      }, 3000);
                    } else {
                      if (lanVerifyTimeout.current) {
                        clearTimeout(lanVerifyTimeout.current);
                      }
                      setLanChecking(false);
                      setLanVerified(false);
                    }
                  }
                }}
                placeholder="Enter LAN Number"
                required={lanMandatoryCheck === "true"}
                minLength={12}
                maxLength={12}
              />
              {lanNumber.length === 12 ? (
                lanChecking ? (
                  <CircularProgress size={16} color="primary" />
                ) : (
                  <div style={{ filter: lanVerified ? "none" : "grayscale(1)" }}>
                    <VerifiedIcon />
                  </div>
                )
              ) : (
                <div style={{ filter: "grayscale(1)" }}>
                  <VerifiedIcon />
                </div>
              )}
            </div>
          </div>

          <div className="flex items-center gap-3">
            <div
              id="utrNO"
              className="h-12 w-[440px] border border-gray-300 flex items-center gap-2 rounded-md p-4 bg-gray-100 text-[14px]"
            >
              <span className="float-left font-semibold">UTR No: </span>
              <input
                type="text"
                value={utrNumber}
                className=" bg-gray-100 text-[14px] text-black outline-none"
                onChange={(e) => {
                  const input = e.target.value;
                  // const alphanumericOnly = input.replace(/[^a-zA-Z0-9]/g, "");
                  setUtrNumber(input);
                }}
                placeholder="Enter UTR Number"
              />
            </div>
          </div>
        </>
      )}

      <div className="relative w-full">
        <div
          ref={dropdownRef}
          onClick={() => setModalOpen(!modalOpen)}
          className="flex items-center cursor-pointer h-12 justify-between py-3 px-5 bg-gray-100 rounded-lg border border-gray-300"
        >
          <div className="flex items-center gap-6">
            {/* <ProfileOutline /> */}
            <span className={"text-[#000000] text-sm font-bold"}>
              {sourceOfFunds === "" ? "Source of Funds" : `Source of Funds:`}
              <span className="font-normal"> {sourceOfFunds}</span>
              <span className="text-lg text-red-100 text-center">
                {sourceOfFunds === "" ? "*" : ""}
              </span>
            </span>
          </div>
          <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-chevron-down"
            >
              <polyline points="6 9 12 15 18 9"></polyline>
            </svg>
          </div>
        </div>
        {modalOpen && (
          <div
            ref={modalRef}
            className="absolute left-0 right-0 w-full mt-2 rounded-2xl bg-white border shadow-2xl z-50"
            style={{
              top: dropdownRef.current
                ? `${dropdownRef?.current.clientHeight && dropdownRef?.current?.clientHeight}px`
                : "auto",
            }}
          >
            <div className="flex flex-col w-full">
              {sourceData.map((element, index) => (
                <div
                  key={index}
                  onClick={() => selectSource(element)}
                  className="py-2 px-6 w-full cursor-pointer hover:border hover:border-blue-500"
                >
                  <div className="text-[14px]">{element.value}</div>
                  {index < sourceData.length - 1 && <hr />}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
      <div id="a2" className="flex flex-row items-start space-x-2 !mt-8">
        {/* <div className="flex items-center">
          <InfoIcon fillColor="black" />
          <span className="ml-3">A2 Form</span>
        </div> */}

        {eSign ? (
          <>
            <div className="flex items-center space-x-6 w-full">
              <Button
                bgColor="bg-primary-150"
                onClickHandler={viewA2Form}
                fontStyle={buttonStyle}
                className="px-6 py-2 w-full font-bold transition-all rounded-md view-button hover:bg-secondary-150 hover:scale-105"
              >
                {isViewingA2Form ? (
                  <div className="animate-spin rounded-full border-4 border-t-4 border-blue-500 h-6 w-6"></div>
                ) : (
                  "Signed A2 Form"
                )}
              </Button>
              <Button
                bgColor="bg-primary"
                onClickHandler={handleA2Form}
                fontStyle={buttonStyle}
                className="px-6 py-2 w-full font-bold transition-all rounded-md a2-download-button hover:bg-primary-150 hover:scale-105"
              >
                Download Signed A2 Form
              </Button>
              {/* <span className="text-green-600 font-bold">{"Signed "} </span> */}
            </div>
          </>
        ) : null}
        {!eSign && linkSent ? (
          <div className="flex flex-col w-full">
            <div className="flex items-center space-x-6 w-full">
              <Button
                bgColor="bg-primary-150"
                onClickHandler={viewA2Form}
                fontStyle={buttonStyle}
                className="px-6 py-2 font-bold transition-all rounded-md view-button hover:bg-primary-150 hover:scale-105 w-fit"
              >
                {isViewingA2Form ? (
                  <div className="animate-spin rounded-full border-4 border-t-4 border-blue-500 h-6 w-6"></div>
                ) : (
                  "View A2 Form"
                )}
              </Button>
              <Button
                bgColor="bg-primary"
                onClickHandler={handleA2Form}
                fontStyle={buttonStyle}
                className="px-6 py-2 w-fit font-bold transition-all rounded-md a2-download-button hover:bg-primary-150 hover:scale-105"
              >
                Download A2 Form
              </Button>
            </div>
            {/* <span className="text-red-600 font-bold mr-2">{"( Link Sent )"} </span> */}
          </div>
        ) : null}
        {/* {!linkSent && !eSign && !signLater ? (
          <span className="text-red-600 font-bold"> {"( Not Signed )"} </span>
        ) : null} */}
        {!linkSent && !eSign && !signLater ? (
          <>
            <Button
              bgColor="bg-primary-150"
              onClickHandler={viewA2Form}
              fontStyle={buttonStyle}
              className="px-6 py-2 font-bold transition-all rounded-md view-button hover:bg-primary-150 hover:scale-105 w-fit"
            >
              {isViewingA2Form ? (
                <div className="animate-spin rounded-full border-4 border-t-4 border-blue-500 h-6 w-6"></div>
              ) : (
                "View A2 Form"
              )}
            </Button>
            <Button
              bgColor="bg-primary-150"
              onClickHandler={handleSignA2Form}
              fontStyle={buttonStyle}
              className="px-6 py-2 font-bold transition-all rounded-md view-button hover:bg-primary-150 hover:scale-105"
            >
              Sign A2 Form
            </Button>
            {/* <Button
              bgColor="bg-primary-150"
              onClickHandler={handleSignA2Form}
              fontStyle={buttonStyle}
              className="px-6 py-2 font-bold transition-all rounded-md view-button hover:bg-primary-150 hover:scale-105"
            >
              Sign A2 Form
            </Button> */}
            {/* // <h1 className="flex font-bold">
          //   <span className="text-red-600 mr-2">( A2 form not signed</span>
          //   <span onClick={handleSignA2Form} className="text-primary cursor-pointer">
          //     Sign Now )
          //   </span>
          // </h1> */}
          </>
        ) : null}
        {!linkSent && !eSign && signLater ? (
          <>
            <Button
              bgColor="bg-primary-150"
              onClickHandler={viewA2Form}
              fontStyle={buttonStyle}
              className="px-6 py-2 font-bold transition-all rounded-md view-button hover:bg-primary-150 hover:scale-105"
            >
              {isViewingA2Form ? (
                <div className="animate-spin rounded-full border-4 border-t-4 border-blue-500 h-6 w-6"></div>
              ) : (
                "View A2 Form"
              )}
            </Button>
            <Button
              bgColor="bg-primary-150"
              onClickHandler={handleSignA2Form}
              fontStyle={buttonStyle}
              className="px-6 py-2 font-bold transition-all rounded-md view-button hover:bg-primary-150 hover:scale-105"
            >
              Sign A2 Form
            </Button>
            {/* // <h1 className="flex font-bold">
          //   <span className="text-red-600 mr-2">( A2 form not signed</span>
          //   <span onClick={handleSignA2Form} className="text-primary cursor-pointer">
          //     Sign Now )
          //   </span>
          // </h1> */}
          </>
        ) : null}
      </div>
      {/* {currentUser.username.includes("moneyhop.co") && (
        <div className="!mt-0">
          <Button
            bgColor="bg-primary"
            onClickHandler={() => {
              setShowDeclaration(true);
            }}
            fontStyle={buttonStyle}
            className="px-6 py-2 w-fit h-[40px] font-bold transition-all rounded-md a2-download-button hover:bg-primary-150 hover:scale-105"
          >
            Declarations
            <span className="text-red-100 pl-[0.05rem] text-lg">
            *
            </span>
          </Button>
        </div>
      )} */}

      {/* {((!eSign && signLater) || eSign || linkSent) && (
        <div>
          {currentUser.username.includes("moneyhop.co") && (
            <div id="dualTransaction/referrer">
              <div id="DTInput">
                <span className="font-ssp font-semibold text-[18px]">Dual Transaction</span>
                <div className="flex space-x-5">
                  <input
                    type="text"
                    placeholder="Enter Parent Txn Number"
                    className={clsx(
                      dualError
                        ? "border-2 border-red-500 p-2 rounded-md w-[300px] h-[40px] mt-3"
                        : dualVerified
                        ? "border-2 border-green-500 p-2 rounded-md w-[300px] h-[40px] mt-3"
                        : "border-2 border-black p-2 rounded-md w-[300px] h-[40px] mt-3",
                    )}
                    value={dualNumber}
                    onChange={(e) => setDualNumber(e.target.value)}
                    autoComplete="off"
                    pattern="[a-zA-Z0-9 ]{1,}"
                  />
                  <button
                    onClick={verifyDual}
                    className={clsx(
                      dualVerified
                        ? "px-14 bg-green-500 text-white mt-3 font-bold rounded-lg"
                        : dualError
                        ? "px-14 bg-red-500 text-white mt-3 font-bold rounded-lg"
                        : "px-14 bg-black-500 text-white mt-3 font-bold rounded-lg",
                    )}
                  >
                    {dualVerified ? "Verified" : "Verify"}
                  </button>
                </div>
                <span className="text-red-500 font-semibold text-[13px]">{dualError}</span>
              </div>
              <div id="DTInput" className="mt-5">
                <span className="font-ssp font-semibold text-[18px]">
                  Enter Referrer Vendor Code
                </span>
                <div className="flex flex-col space-x-5">
                  <div>
                    <Autocomplete
                      value={referrer}
                      onChange={(event: any, newValue: string | null) => {
                        setReferrer(newValue);
                        newValue && localStorage.setItem("referrerVendorCode", newValue);
                      }}
                      inputValue={inputValue}
                      onInputChange={(event, newInputValue) => {
                        setInputValue(newInputValue);
                      }}
                      id="controllable-states-demo"
                      options={vendorCodes}
                      style={{ width: 300, marginTop: "15px" }}
                      renderInput={(params) => <TextField {...params} label="Vendor Codes" />}
                    />
                  </div>
                  {referrer === "" && (
                    <span className="text-[16px] mt-4 font-ssp text-red-500">
                      {referrer === "" && "Please Choose a Vendor Code"}
                    </span>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      )} */}
      <div id="a2-form-error-message" className="flex flex-col mt-2 w-full">
        {A2errorMessage && (
          <div className=" flex flex-col px-4 py-2 mb-0 text-m text-center text-red-600">
            {A2errorMessage}
          </div>
        )}
      </div>
      {((!eSign && signLater) || eSign || linkSent) && (
        <div className="flex flex-col !mt-[2%]">
          <form onSubmit={handleClick} className="space-y-2">
            <div className="flex">
              <input
                type="checkbox"
                checked={isCheckedTermsAndCondition && isCheckedA2Form}
                onChange={() => {
                  handleTermsAndCondition();
                  handleAgreeA2Form();
                }}
                required
                className="review-checkbox w-11 h-11"
              />

              <label className="ml-2 font-medium font-sans text-[16px] flex items-center">
                <p>
                  I confirm that the information captured in the A2 Form is accurate
                  <span> and agree to the</span>
                  <span
                    className=" text-blue-500 cursor-pointer hover:underline"
                    onClick={() => {
                      setIsModalOpen("tnc");
                    }}
                  >
                    {" Terms & Conditions. "}
                  </span>
                </p>
              </label>
            </div>
            {/* <div className="mt-4">
              <input
                type="checkbox"
                checked={isCheckedA2Form}
                onChange={handleAgreeA2Form}
                className="bg-primary-200 review-checkbox"
                required
              />

              <label className="ml-2 font-medium font-sans text-[18px]">
                {"I confirm that the information captured in the A2 Form is accurate."}
              </label>
            </div> */}

            <div className="flex">
              <input
                type="checkbox"
                required
                className="review-checkbox w-[70px] h-8"
                onClick={() => setConsentCheckbox(!consentCheckbox)}
              />
              <label className="ml-2 font-medium font-sans text-[16px] flex items-center">
                <p>
                  As the authorized representative of the Remitter, I hereby acknowledge and accept
                  the defined
                  <span
                    className="text-blue-600 cursor-pointer hover:underline"
                    onClick={() => setIsContentModalOpen(true)}
                  >
                    {" "}
                    roles, responsibilities, and timelines{" "}
                  </span>
                  associated with the transaction.{" "}
                </p>
              </label>
            </div>

            <input
              onClick={handleClick}
              name="review-pay-button"
              type={"submit"}
              className={clsx(
                disablePay
                  ? "review-pay-button mt-5 m-auto w-full h-[50px] opacity-50 bg-primary-200 rounded-[150px] cursor-not-allowed text-black text-[20px] font-bold items-end"
                  : "review-pay-button mt-5 m-auto w-full  h-[50px] bg-primary-200 rounded-[150px] cursor-pointer text-white text-[20px] font-bold hover:scale-105 hover:bg-red-200 transition-all"
              )}
              value={"PAY"}
              disabled={disablePay}
            />
            <div className="flex justify-center">
              {errorMessage && <ErrorField errorMessage={errorMessage} />}
            </div>
          </form>
        </div>
      )}
      <DeclarationModal
        isDeclarationModal={showDeclaration}
        setDeclarationModal={setShowDeclaration}
        enableDelcaration={setDeclarationy}
        type="online"
        ref={declarationModalRef}
      />
    </div>
  );
};
